<template>
  <section class="legends">
    <div class="legend legend_average">
      <span class="legend_average__icon">M</span> :
      <span v-if="forPlayers">Note moyenne du joueur (attribuée aux joueurs dont le match n'a pas commencé)</span>
      <span v-else>Score calculé avec des notes moyennes de joueurs (attribuée aux joueurs dont le match n'a pas commencé)</span>
    </div>
    <div v-if="forPlayers" class="legend">
      <span class="legend legend_live__icon" /> :
      <span>Match du joueur en cours</span>
    </div>
    <div v-if="forPlayers" class="legend">
      <span class="legend legend_live_substitute__icon" /> :
      <span>Joueur remplaçant dans un match en cours</span>
    </div>
    <div v-if="forPlayers" class="legend">
      <span class="legend_live-substitued__icon">
        <substitution-icon is-out />
      </span>
      <span> : Joueur remplacé dans un match en cours</span>
    </div>
    <div v-if="forPlayers" class="legend">
      <span class="legend_final-substitute__icon">
        X
      </span>
      <span> : Joueur qui ne peut plus rentrer dans un match en cours</span>
    </div>
  </section>
</template>

<script setup>
import SubstitutionIcon from "@/components/icons/SubstitutionIcon.vue";

defineProps({
  forPlayers: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss" scoped>
.legends {
  font-size: 0.8rem;
  display:flex;
  column-gap: 10px;
  flex-wrap: wrap;
  text-align: left;

  .legend {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: 5px;

    &_average__icon {
      display: inline-block;
      min-width: 15px;
      min-height: 15px;
      line-height: 15px;
      background-color: var(--bs-yellow);
      color: #333;
      font-size: 9px;
      font-weight: bold;
      border-radius: 50%;
      text-align: center;
    }

    &_live__icon {
      display: inline-block;
      width: 10px;
      height: 10px;
      background-color: var(--bs-red);
      color: #fff;
      font-weight: bold;
      border-radius: 50%;
      text-align: center;
    }

    &_live-substitued__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid var(--bs-red);
      border-radius: 100%;
    }

    &_live_substitute__icon {
      border: 1px solid var(--bs-red);
      border-radius: 100%;
      color: #fff;
      width: 10px;
      height: 10px;
    }

    &_final-substitute__icon {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid var(--bs-red);
      border-radius: 50%;
      color: var(--bs-red);
      width: 10px;
      height: 10px;
    }
  }

}
</style>